import { cloneDeep } from 'lodash';
import * as moment from 'moment';
import { actionEqual } from './utils';
import * as ActionCreators from '../actions/ActionCreators';

const defaultState: EntitiesState = {
  channel: {
    byId: {},
    searchResults: [], // dummy
  },
  preference_product: {
    byId: {},
    searchResults: [], // dummy
  },
  data_item: {
    byId: {},
    searchResults: [],
  },
  shop_item: {
    byId: {},
    searchResults: [],
  },
  shop_item_category: {
    byId: {},
    searchResults: [],
  },
  data_item_view: {
    byId: {},
    searchResults: [], // dummy
  },
  user_favourite_tag: {
    byId: {},
    searchResults: [],
  },
};

const setChannelEntity = (nextState: EntitiesState, channel: Channel) => {
  nextState.channel.byId[channel.id] = channel;
};

const setPreferenceProductEntity = (
  nextState: EntitiesState,
  p: PreferenceProduct
) => {
  nextState.preference_product.byId[p.id] = p;
};

const setShopItemCategoryEntity = (
  nextState: EntitiesState,
  item: ShopItemCategory
) => {
  nextState.shop_item_category.byId[item.id] = item;
  item.channel && setChannelEntity(nextState, item.channel);
};

const setShopItemEntity = (nextState: EntitiesState, item: ShopItem) => {
  if (item.channel) {
    setChannelEntity(nextState, item.channel);
    item.company_channel_id = item.channel.id; // some tests fail without this code
  }
  nextState.shop_item.byId[item.id] = item;
};

const setDataItemEntity = (nextState: EntitiesState, item: DataItem) => {
  nextState.data_item.byId[item.id] = item;
  item.channel && setChannelEntity(nextState, item.channel);
  item.preference_product &&
    setPreferenceProductEntity(nextState, item.preference_product);
};

const setDataItemViewEntity = (nextState: EntitiesState, item: DataItem) => {
  // backend doesn't return view.item_id for now ...
  // need to get it from view.item.id
  if (item) {
    const item_id = item.id;
    nextState.data_item_view.byId[item_id] = item;
    setDataItemEntity(nextState, item);
  }
};

export default function entities(
  state: EntitiesState = defaultState,
  action: Action
): EntitiesState {
  if (actionEqual(action, ActionCreators.actionDataItemView)) {
    const nextState = cloneDeep(state);
    action.payload.data_item_views.forEach(i =>
      setDataItemViewEntity(nextState, i)
    );
    return nextState;
  } else if (actionEqual(action, ActionCreators.actionAddBuyShopItem)) {
    const nextState = cloneDeep(state);
    setShopItemEntity(nextState, action.payload.shopItem);
    return nextState;
  } else if (actionEqual(action, ActionCreators.receivedCatalogSearchResults)) {
    const nextState = cloneDeep(state);
    const p = action.payload;
    nextState.data_item.searchResults = p.data_items.map(i => i.id);
    nextState.shop_item.searchResults = p.shop_items.map(i => i.id);
    nextState.shop_item_category.searchResults = p.shop_item_categories.map(
      i => i.id
    );
    p.data_items.forEach(i => setDataItemEntity(nextState, i));
    p.shop_items.forEach(i => setShopItemEntity(nextState, i));
    p.shop_item_categories.forEach(i =>
      setShopItemCategoryEntity(nextState, i)
    );
    return nextState;
  } else if (actionEqual(action, ActionCreators.receivedFetchUserShopItemAll)) {
    const nextState = cloneDeep(state);
    action.payload.shop_items.forEach(shopItem => {
      setShopItemEntity(nextState, shopItem);
    });
    return nextState;
  } else if (actionEqual(action, ActionCreators.actionDataItemPrices)) {
    const nextState = cloneDeep(state);
    // for now, simply just update prices only. sort here not to recalculate
    action.payload.data_items.forEach(item => {
      const prices = [...item.prices].sort((a, b) =>
        moment(a.created_at).diff(moment(b.created_at))
      );
      nextState.data_item.byId[item.id].prices = prices;
    });
    return nextState;
  } else if (actionEqual(action, ActionCreators.actionSetUserFavouriteTags)) {
    const nextState = cloneDeep(state);
    action.payload.user_favourite_tags.forEach(item => {
      nextState.user_favourite_tag.byId[item.id] = item;
    });
    return nextState;
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/entities.ts